import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'

import {
  Field,
  SimpleSelectField,
  ValueSelector,
  TextField,
  SelectField,
} from 'discada/dist/Form'

import { INTENTS } from 'reducers/quoteReducers'
import {
  getHasDraiver,
  getShowHomeDelivery,
} from 'selectors/appStatusSelectors'

import { states } from 'utils'

import './Scheduler.scss'

//////////////////////////////////////
export const AddressField = ({ appointment = {}, setAppointment }) => {
  let { street1, street2, city, state, zip } = appointment.address || {},
    c = key => e => setAppointment(`address.${key}`, e)

  return (
    <div className="address-field">
      <label>Where can we meet?</label>
      <div>
        <TextField
          className="address-street1"
          placeholder="Street Address"
          value={street1}
          onChange={c('street1')}
          rounded
        />
        <TextField
          className="address-street2"
          placeholder="Street Address 2"
          value={street2}
          onChange={c('street2')}
          rounded
        />
      </div>
      <div>
        <TextField
          className="address-city"
          placeholder="City"
          value={city}
          onChange={c('city')}
          rounded
        />
        <SelectField
          className="address-state"
          value={state}
          onChange={c('state')}
          placeholder="State"
          options={states}
          rounded
        />
        <TextField
          className="address-zip"
          placeholder="Zip"
          value={zip}
          onChange={c('zip')}
          rounded
        />
      </div>
    </div>
  )
}
//////////////////////////////////////

export const STARTING_APPT = {
  type: 'NOT_SURE',
  date: null,
  time: null,
}

export const APPT_TIMES = ['Anytime', 'Morning', 'Afternoon', 'Evening'].reduce(
  (ret, t) => ({ ...ret, [t]: t }),
  {},
)

export const APPT_LABELS = {
  IN_STORE: 'In Store',
  AT_HOME: 'At Home',
  NOT_SURE: 'Not Sure',
}

export const APPT_TYPES_SEE = {
  NOT_SURE: <span>I'm not sure yet...</span>,
  IN_STORE: (
    <span>
      I want an <strong>in-store test-drive!</strong>
    </span>
  ),
  AT_HOME: (
    <span>
      I want an <strong>at-home test-drive!</strong>
    </span>
  ),
}

export const APPT_TYPES_BUY = {
  NOT_SURE: <span>I'm not sure yet...</span>,
  IN_STORE: (
    <span>
      I want to <strong>buy in store</strong>!
    </span>
  ),
  AT_HOME: (
    <span>
      I want to <strong>buy at home</strong>!
    </span>
  ),
}

export const APPT_TYPES_TRADE = {
  NOT_SURE: <span>I'm not sure yet...</span>,
  IN_STORE: (
    <span>
      I want an <strong>in store appraisal</strong>!
    </span>
  ),
  AT_HOME: (
    <span>
      I want an <strong>at home appraisal</strong>!
    </span>
  ),
}

function makeDays(start = moment().add(1, 'day'), numDays = 14) {
  let ret = []

  while (ret.length < numDays) {
    ret = [
      ...ret,
      moment(start)
        .add(ret.length, 'days')
        .format('dddd MMMM Do'),
    ]
  }

  return [...ret, 'Any Day'].reduce((ret, d) => ({ ...ret, [d]: d }), {})
}

export class Scheduler extends React.Component {
  render() {
    let { intent, appointment, onChange, showHome } = this.props,
      { type, date, time } = appointment,
      showTimePicker = type !== 'NOT_SURE',
      showAddress = type === 'AT_HOME',
      setAppointment = (key, e) => onChange(`appointment.${key}`)(e),
      types = {
        [INTENTS.buyNow]: APPT_TYPES_BUY,
        [INTENTS.accepted]: APPT_TYPES_SEE,
        [INTENTS.tradeAppraisal]: APPT_TYPES_TRADE,
      }[intent],
      setStartingAppt = target => {
        setAppointment('type', { target })
        setAppointment('date', {
          target: { value: Object.keys(makeDays())[0] },
        })
        setAppointment('time', {
          target: { value: Object.keys(APPT_TIMES)[0] },
        })
      }

    if (isEmpty(types)) return null

    return (
      <div className="reaction-scheduler">
        <label>Do you want to setup an appointment?</label>
        <ValueSelector
          rounded
          selected={type}
          onChange={target => setStartingAppt(target)}
          values={Object.keys(types || {})
            .filter(k => k !== 'AT_HOME' || showHome)
            .reduce((ret, k) => [...ret, { value: k, label: types[k] }], [])}
        />
        {showTimePicker && (
          <>
            <Field className="side-by">
              <div className="field">
                <SimpleSelectField
                  rounded
                  icon="calendar"
                  options={makeDays()}
                  value={date}
                  onChange={e => setAppointment('date', e)}
                />
              </div>
              <div className="field">
                <SimpleSelectField
                  rounded
                  icon="clock"
                  value={time}
                  options={APPT_TIMES}
                  onChange={e => setAppointment('time', e)}
                />
              </div>
            </Field>
            {showAddress && (
              <AddressField {...this.props} setAppointment={setAppointment} />
            )}
            <p className="scheduler-disclaimer">
              We will reach out to you to confirm a date, time and location.
            </p>
          </>
        )}
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let showHome = getShowHomeDelivery(state)

  return {
    ...op,
    showHome,
    hasDraiver: getHasDraiver(state),
    appointment: {
      ...STARTING_APPT,
      ...op.appointment,
    },
  }
}

export default connect(mapStateToProps)(Scheduler)
